import { Pipe, PipeTransform } from '@angular/core';
import { timeAgo } from './time-ago.fn';
import { AppVersionService } from '../domain';

@Pipe({ 
    name: 'timeAgo',
    pure: false
})
export class TimeAgoPipe implements PipeTransform {
    constructor(private appVersion: AppVersionService) {}

    transform(value: any, args?: any): any {
        return timeAgo(value, this.appVersion.effectiveNow);
    }
}
